import { isBoolean, isString } from 'lodash';
import { useEffect, useState } from 'react';
import { useEditor } from '@/hooks/use-editor';

export const useMaskData = () => {
    const editor = useEditor();
    const [maskData, setMaskData] = useState<{
        isShow: boolean;
        background: string;
        text?: string;
        loading?: boolean;
    }>({
        isShow: false,
        background: '',
        loading: false,
    });

    useEffect(() => {
        const handler = editor.tip.onMask((e) => {
            const data = {
                isShow: e.isShow,
                background: e.isHide
                    ? ''
                    : isString(e.data?.background)
                      ? e.data?.background
                      : isBoolean(e.data?.background) && e.data?.background
                        ? 'rgba(0, 0, 0, 0.4)'
                        : '',
                text: e.data?.text,
                loading: e.data?.loading,
            };
            setMaskData(data);
        });
        return () => {
            editor.off(handler);
        };
    }, []);

    return maskData;
};

// 获取真是vh
export function useViewportHeightVar() {
    useEffect(() => {
        const setViewportHeightVar = () => {
            const vh = window.innerHeight;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };

        setViewportHeightVar();
        window.addEventListener('resize', setViewportHeightVar);
        window.addEventListener('orientationchange', setViewportHeightVar);

        return () => {
            window.removeEventListener('resize', setViewportHeightVar);
            window.removeEventListener('orientationchange', setViewportHeightVar);
        };
    }, []);
}
